import React from 'react'
import BlackNavbar from '../../Components/Navbar/Navbar'
import BlackFooter from "../../Components/Footer/Footer";
import Gamesslider from "../../Components/Gamesslider/Gamesslider";
import InventorySlider from "../../Components/Inventoryslider/InventorySlider";
import Marketplace from "../../Components/Marketplaceslider/Marketplace";
import UploadSlider from "../../Components/UploaderimageSlider/UploadSlider";
const BobsCollection = () => {
  return (
    <div>
        <div style={{ background: "#191A1E" }}>
      <BlackNavbar />
      <div style={{ background: "#202125" }}>
        <div className="container inventory">
          <div className="row justify-content-center">
            <div className="col-12 py-2 py-md-4">
              <h3>Bobs Collections</h3>
            </div>
            
          </div>
        </div>
      </div>
      <div>
        <div className="container">
            <div className="row pb-5">
            <div className="col-6 col-sm-3 ">
            {/* <img src={process.env.PUBLIC_URL + '/images/Rectangle.png'} alt="" className="w-50" /> */}
            <div className='bobs_collection' style={{backgroundImage: "url(https://images.pexels.com/photos/9399540/pexels-photo-9399540.jpeg?auto=compress&cs=tinysrgb&w=600)"}}>
                  <h4 className="text-white ps-2">Collection_1</h4>
                  </div>
            </div>
            <div className="col-6 col-sm-3">
            {/* <img src={process.env.PUBLIC_URL + '/images/Rectangle.png'} alt="" className="w-50" /> */}
            <div className='bobs_collection'  style={{backgroundImage: "url(https://images.pexels.com/photos/3165335/pexels-photo-3165335.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1)"}}>
                  <h4 className="text-white ps-2">Collection_2</h4>
                  </div>
            </div>
            <div className="col-6 col-sm-3 ">
           
            <div className='bobs_collection' style={{backgroundImage: "url( https://images.unsplash.com/photo-1511512578047-dfb367046420?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1742&q=80)"}}>
                  <h4 className="text-white ps-2">Collection_3</h4>
                  </div>
            </div>
            <div className="col-6 col-sm-3">
            
            <div className='bobs_collection'  style={{backgroundImage: "url(https://images.pexels.com/photos/46798/the-ball-stadion-football-the-pitch-46798.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1)"}}>
                  <h4 className="text-white ps-2">Collection_4</h4>
                  </div>
            </div>
            <div className="col-6 col-sm-3 ">
           
            <div className='bobs_collection'  style={{backgroundImage: "url( https://images.pexels.com/photos/274422/pexels-photo-274422.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"}}>
                  <h4 className="text-white ps-2">Collection_5</h4>
                  </div>
            </div>
            <div className="col-6 col-sm-3 ">
            {/* <img src={process.env.PUBLIC_URL + '/images/Rectangle.png'} alt="" className="w-50" /> */}
            <div className='bobs_collection' style={{backgroundImage: "url( https://images.pexels.com/photos/159516/soccer-goal-keeper-player-kick-159516.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"}}>
                  <h4 className="text-white ps-2">Collection_6</h4>
                  </div>
            </div>
            <div className="col-6 col-sm-3 ">
            {/* <img src={process.env.PUBLIC_URL + '/images/Rectangle.png'} alt="" className="w-50" /> */}
            <div className='bobs_collection' style={{backgroundImage: "url( https://images.pexels.com/photos/1476146/pexels-photo-1476146.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"}}>
                  <h4 className="text-white ps-2">Collection_7</h4>
                  </div>
            </div>
            <div className="col-6 col-sm-3">
            {/* <img src={process.env.PUBLIC_URL + '/images/Rectangle.png'} alt="" className="w-50" /> */}
            <div className='bobs_collection' style={{backgroundImage: "url( https://images.pexels.com/photos/264420/pexels-photo-264420.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"}}>
                  <h4 className="text-white ps-2">Collection_8</h4>
                  </div>
            </div>
            <div className="col-6 col-sm-3 ">
            {/* <img src={process.env.PUBLIC_URL + '/images/Rectangle.png'} alt="" className="w-50" /> */}
            <div className='bobs_collection' style={{backgroundImage: "url( https://images.pexels.com/photos/2190188/pexels-photo-2190188.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"}}>
                  <h4 className="text-white ps-2">Collection_9</h4>
                  </div>
            </div>
            <div className="col-6 col-sm-3 ">
            {/* <img src={process.env.PUBLIC_URL + '/images/Rectangle.png'} alt="" className="w-50" /> */}
            <div className='bobs_collection'style={{backgroundImage: "url( https://images.pexels.com/photos/1618290/pexels-photo-1618290.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"}}>
                  <h4 className="text-white ps-2">Collection_10</h4>
                  </div>
            </div>
            <div className="col-6 col-sm-3 ">
            {/* <img src={process.env.PUBLIC_URL + '/images/Rectangle.png'} alt="" className="w-50" /> */}
            <div className='bobs_collection' style={{backgroundImage: "url( https://images.pexels.com/photos/1349959/pexels-photo-1349959.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"}}>
                  <h4 className="text-white ps-2">Collection_11</h4>
                  </div>
            </div>
            <div className="col-6 col-sm-3">
            {/* <img src={process.env.PUBLIC_URL + '/images/Rectangle.png'} alt="" className="w-50" /> */}
            <div className='bobs_collection' style={{backgroundImage: "url( https://images.pexels.com/photos/1349515/pexels-photo-1349515.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"}}>
                  <h4 className="text-white ps-2">Collection_12</h4>
                  </div>
            </div>
            </div>
        </div>
      </div>
     
    </div>
    <BlackFooter />
    </div>
  )
}

export default BobsCollection
